import {createContext, useContext, useEffect, useState} from "react";
import axiosInstance from "../api/axiosInstance";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        await refreshUser();
      }
      setLoading(false);
    };

    fetchUser();
  }, []);

  const completeAuthSession = async ({ access, refresh, user }) => {
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);

    if (user) {
      setCurrentUser(user);
      return user;
    }

    const userRes = await axiosInstance.get("/api/user/profile/");
    setCurrentUser(userRes.data);
    return userRes.data;
  };

  const login = async (email, password) => {
    const res = await axiosInstance.post("/api/auth/jwt/create/", { email, password });
    return completeAuthSession(res.data);
  };

  const loginWithTokens = async (accessToken, refreshToken) => {
    return completeAuthSession({ access: accessToken, refresh: refreshToken });
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setCurrentUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await axiosInstance.get("/api/user/profile/");
      setCurrentUser(res.data);
      return res.data;
    } catch (err) {
      console.error("Failed to refresh user", err);
      setCurrentUser(null);
      return null;
    }
  };

  const updateCurrentUser = async (payload) => {
    const res = await axiosInstance.patch("/api/user/profile/", payload, {
      headers: { "Content-Type": "application/json" },
    });
    setCurrentUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ currentUser, login, loginWithTokens, completeAuthSession, logout, refreshUser, updateCurrentUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
